<script>
import { getAvailableHeight } from 'sky-engine/utils/dom'
import tableController from 'sky-engine/views/tableController'
import { createViewVNode } from 'sky-engine/views/ViewManager'

import { CASE_MNG } from '@/api/apiModules'

export default {
  name: 'StepViewTestCaseDetail',
  components: {
    tableController
  },
  props: {
    params: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mounted() {},
  watch: {
    params: {
      handler: function(value) {
        this.updateTableData()
      },
      deep: true
    }
  },
  methods: {
    updateAvailableHeight() {
      this.$refs.StepViewTestCaseDetail.availableHeight = getAvailableHeight(this.$el) + this._rem2px(55)
    },
    updateTableData(version) {
      // 使用新的版本信息来更新表格数据
      this.$refs.StepViewTestCaseDetail.viewMetaData.params = this.params
      this.$refs.StepViewTestCaseDetail.fetch()
    },
    getData() {
      var select = this.$refs.StepViewTestCaseDetail.cacheSelection
      var selectId = []
      for (const iterator of select) {
        selectId.push(iterator.id)
      }
      return selectId
    },
    async gotoNextPreVliate() {
      return true
    },
    gotoNextStep() {
      this.message = '点击了下一步'
      return true
    },
    gotoPreStep() {
      this.message = '点击了上一步'
    }
  },
  data() {
    const metaView = {
      viewType: 'table',
      refreshInterval: false,
      module: `${CASE_MNG}/inst`,
      class: 'sky-expand-view',
      ref: 'StepViewTestCaseDetail',
      sortArr: [],
      toolbar: {
        searchPlaceholder: 'testcaseMng.searchPlaceholder.testCaseName',
        searchFieldNameArr: ['testCaseName']
      },
      params: this.params,
      allowStatus: {},
      cb: function() {
        // 解决刷新后展开会自动关闭问题
      },
      view: {
        rowKey: 'id',
        expandRowKeys: [],
        columns: [
          {
            props: {
              type: 'selection',
              width: 55
            }
          },
          {
            props: {
              label: 'testcaseMng.testProductVersion',
              prop: 'testProductVersion'
            }
          },
          {
            props: {
              label: 'testcaseMng.testCaseScene',
              prop: 'sceneName'
            }
          },
          {
            props: {
              label: 'testcaseMng.featureName',
              prop: 'featureName'
            }
          },
          {
            props: {
              label: 'testcaseMng.testCaseName',
              prop: 'testCaseName'
            }
          }
        ],
        menus: []
      }
    }
    return {
      metaView: metaView
    }
  },
  render(h) {
    return createViewVNode(this.metaView, h)
  }
}
</script>
